import { Grid2 } from "components";
import { useLocation } from "react-router-dom";
import WelcomePage from "./WelcomePage";

const InvestorOnboarding = () => {
  const location = useLocation();

  const logo = location.search.split("logo=")[1];

  return (
    <Grid2
      container
      bgcolor="#F8FAFC"
      height="100%"
      minHeight={"100vh"}
      width={"100vw"}
      overflow={"auto"}
    >
      <Grid2
        size={12}
        py={2}
        px={4}
        display="flex"
        alignItems="center"
        borderBottom={`1px solid var(--neutral-100)`}
      >
        <img
          src={logo || "/Logos/iconFullLogo.png"}
          alt=""
          height={`-webkit-fill-available`}
          width={"auto"}
          style={{ maxHeight: "32px" }}
          onError={({ currentTarget }) => {
            currentTarget.src = "https://gridkey.in/Logos/iconFullLogo.png";
          }}
        />
      </Grid2>
      <Grid2
        size={12}
        sx={{ p: { xs: 2, md: 10 } }}
        maxHeight={"calc(100vh - 65px)"}
        minHeight={"calc(100vh - 65px)"}
        overflow={"auto"}
      >
        <WelcomePage />
      </Grid2>
    </Grid2>
  );
};

export default InvestorOnboarding;
